'use strict';

const {CONTENT_TYPES} = require('../constants');

module.exports[CONTENT_TYPES.DATE] = require('./dateParser');
module.exports[CONTENT_TYPES.GEO] = require('./geoParser');
module.exports[CONTENT_TYPES.IMAGE] = require('./imageParser');
module.exports[CONTENT_TYPES.MULTIPLE_CHOICE] = require('./multipleChoiceParser');
module.exports[CONTENT_TYPES.NUMBER] = require('./numberParser');
module.exports[CONTENT_TYPES.SINGLE_CHOICE] = require('./singleChoiceParser');
module.exports[CONTENT_TYPES.SINGLE_CHOICE_BATTERY] = require('./singleChoiceBatteryParser');
module.exports[CONTENT_TYPES.MULTIPLE_CHOICE_BATTERY] = require('./multipleChoiceBatteryParser');
module.exports[CONTENT_TYPES.STRING] = require('./stringParser');
module.exports[CONTENT_TYPES.MULTIPLE_NUMBER3_BATTERY] = require('./multipleNumber3BatteryParser');
module.exports[CONTENT_TYPES.RANK] = require('./rankParser');
